import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { VerifySignUpPayload } from "../type";

function useSignUpVerify() {
  return useMutation({
    mutationFn: (command: VerifySignUpPayload) => {
      return authService.SignUpVerify(command);
    },
  });
}

export default useSignUpVerify;
